/**
 * Move um item de `de` para `para` sem mutar a lista original.
 */
export function moverItemNaLista<T>(
  lista: readonly T[],
  de: number,
  para: number,
): T[] {
  if (
    de < 0 ||
    para < 0 ||
    de >= lista.length ||
    para >= lista.length ||
    de === para
  ) {
    return [...lista];
  }
  const copia = [...lista];
  const [item] = copia.splice(de, 1);
  if (item === undefined) return [...lista];
  copia.splice(para, 0, item);
  return copia;
}
